import ServerDirections from '@/config/server-directions'
import { GuestCategory } from '@/entities/GuestCategory'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class GuestCategoryRequests {
  list () {
    const route = ServerDirections.GUEST_CATEGORIES
    const method = 'get'
    function map (data) {
      return data.map(item => new GuestCategory(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
